import { render, staticRenderFns } from "./addr.vue?vue&type=template&id=59ba4112&"
import script from "./addr.vue?vue&type=script&lang=js&"
export * from "./addr.vue?vue&type=script&lang=js&"
import style0 from "./addr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports